(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@js4Cytoscape/cyannotationCx2Js"] = factory();
	else
		root["@js4Cytoscape/cyannotationCx2Js"] = factory();
})(self, function() {
return 